import { create } from "./resettable-store";
import { devtools } from "zustand/middleware";
import { GymScheduleStatus } from "@/api/gym-schedules/types";

export interface GymScheduleState {
  gymScheduleId: number | null;
  gymScheduleStatus: GymScheduleStatus | null;
  gymScheduleStartsAt: string | null;
  gymScheduleEndsAt: string | null;
  setGymSchedule: (
    id: number,
    status: GymScheduleStatus,
    startsAt: string,
    endsAt: string,
  ) => void;
  clearGymSchedule: () => void;
}

export const useGymScheduleStore = create<GymScheduleState>()(
  devtools(
    (set) => ({
      gymScheduleId: null,
      gymScheduleStatus: null,
      gymScheduleStartsAt: null,
      gymScheduleEndsAt: null,

      setGymSchedule: (id, status, startsAt, endsAt) =>
        set(
          {
            gymScheduleId: id,
            gymScheduleStatus: status,
            gymScheduleStartsAt: startsAt,
            gymScheduleEndsAt: endsAt,
          },
          false,
          "setGymSchedule",
        ),

      clearGymSchedule: () =>
        set(
          {
            gymScheduleId: null,
            gymScheduleStatus: null,
            gymScheduleStartsAt: null,
            gymScheduleEndsAt: null,
          },
          false,
          "clearGymSchedule",
        ),
    }),
    { name: "gym-schedule-store" },
  ),
);
